export async function useActivityTypes(vacancyType?: MaybeRef<VacancyType>) {
  const vacancyTypeRef = toRef(vacancyType)

  // Flag to make sure that only Heumen's users can see children. Needs to be discussed with the client.
  const includeChildren = true

  // Caching
  const allActivityTypes = useState<ActivityType[]>('allActivityTypes', () => [])

  // TODO: this doesn't work with ClientOnly, see Activity/Search.vue.
  // needs to be fixed/refactored.
  async function fetch() {
    // Fetching
    if (!allActivityTypes.value || !allActivityTypes.value.length) {
      // This is returning with status 'idle', caused by ClientOnly
      const { activityTypes } = await fetchActivityTypes()
      allActivityTypes.value = activityTypes.value ?? []

      if (!includeChildren) {
        allActivityTypes.value = allActivityTypes.value.filter(type => !type.parentId)
      }
    }
  }
  await fetch()

  // Filtering
  // Currently, we're using a different set of activity types for activities.
  // Otherwise, return all activity types that don't have a vacancyType
  const typesToFilter = [VacancyType.Activity]
  const filteredActivityTypes = computed(() =>
    allActivityTypes.value.filter((activityType) => {
      // Check if we're filtering on type
      if (vacancyTypeRef.value && typesToFilter.includes(vacancyTypeRef.value)) {
        return activityType.vacancyType === vacancyTypeRef.value
      }
      // Ohterwise return all activity types that don't have a vacancyType
      return !activityType.vacancyType
    }),
  )

  // Get all parent activity types, filtered by vacancy type
  const parentActivityTypes = computed(() => {
    return filteredActivityTypes.value.filter(activityType => !activityType.parentId)
  })

  // Get all child activity types, filtered by vacancy type
  const childActivityTypes = computed(() => {
    return filteredActivityTypes.value.filter(activityType => !!activityType.parentId)
  })

  // Get child activity types by parent id, filtered by vacancy type
  function getChildActivityTypes(parentId: id) {
    return childActivityTypes.value.filter(activityType => activityType.parentId === parentId)
  }

  // Build a hierarchical list where each parent includes a children[] array
  const hierarchicalActivityTypes = computed(() => {
    return parentActivityTypes.value.map(parent => ({
      ...parent,
      children: getChildActivityTypes(parent.id),
    }))
  })

  return {
    // State
    allActivityTypes,
    activityTypes: filteredActivityTypes,
    parentActivityTypes,
    childActivityTypes,
    hierarchicalActivityTypes,
    // Methods
    getChildActivityTypes,
    fetch,
  }
}
